import TabbedNavigation from './TabbedNavigation';

export default TabbedNavigation;